import { render, staticRenderFns } from "./basic-data.vue?vue&type=template&id=29b3975c&scoped=true&"
import script from "./basic-data.vue?vue&type=script&lang=js&"
export * from "./basic-data.vue?vue&type=script&lang=js&"
import style0 from "./basic-data.vue?vue&type=style&index=0&id=29b3975c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b3975c",
  null
  
)

export default component.exports